export default {
      id: "video-control-play-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#video-control-play",
      toString: function () {
        return this.url;
      }
    }